import React, { ReactNode } from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import { ClickAwayListener, MenuList, Paper, Popper } from '@mui/material'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  paper: {
    backgroundColor: theme.mode.backgroundColor.default,
    boxShadow: 'none',

  },
  menuList: {
    width: 250,
    padding: 0,
  },
}), { name: 'MenuPopover' })

interface MenuPopoverProps {
  open: boolean,
  anchorEl: Element,
  children: ReactNode,
  popperOptions?: object,
  onClose: (e) => void
}

const MenuPopover = (props: MenuPopoverProps) => {
  const classes = useStyles()
  const { open, anchorEl, children, onClose } = props

  const handleClose = (e): void => {
    onClose(e)
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      style={{
        zIndex: '1500',
        boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.1), 0px 3px 30px 0px rgba(0,0,0,0.1), 0px 0px 0px 0px rgba(0,0,0,0.1)',
      }}
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 5],
          },
        },
      ]}
      data-qs-id='menuPopover'
    >
      <Paper classes={{ root: classes.paper }}>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList className={classes.menuList}>
            {children}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  )
}

export default MenuPopover
